import React, { useContext, useEffect, useState } from 'react'
import { HelpdeskContext } from './Helpdesk';

function ChatHeaderUser() {
    const { stateHelpdesk, dispatchHelpdesk } = useContext(HelpdeskContext);
    const initialState = (
        <div className="col-6">
            <h4></h4>
            <div className="ticket-info"></div>
        </div>
    )
    const [renderUser, setrenderUser] = useState(initialState)
    useEffect(() => {
        if (stateHelpdesk.active != null && stateHelpdesk.chats.length > 0) {
            const chat = stateHelpdesk.chats.find(chat => chat.complaint_id == stateHelpdesk.active)
            setrenderUser(
                <div className="col-6">
                    <h4>{chat.username}</h4>
                    <div className="ticket-info" style={{ fontSize: '0.9em' }}>{chat.category_name}</div>
                </div>
            )
        } else {
            setrenderUser(initialState)
        }
    }, [stateHelpdesk.active, stateHelpdesk.chat])
    return (
        renderUser
    )
}

export default ChatHeaderUser
